export const REPORT_ERROR = 'REPORT_ERROR';
export const SEARCH_BY_UNIQUE_PARAM = 'SEARCH_BY_UNIQUE_PARAM';
export const SEARCH_BY_NAME_DOB = 'SEARCH_BY_NAME_DOB';
export const SEARCH_FAILED = 'SEARCH_FAILED';
export const REMOVE_APPOINTEE = 'REMOVE_APPOINTEE';
export const GET_APSAPPOINTEEDATA = 'GET_APSAPPOINTEEDATA';
export const GET_APSAPPOINTEEDATAEXPORT = 'GET_APSAPPOINTEEDATAEXPORT';
export const GET_APSAPPOINTEEDATADETAILS = 'GET_APSAPPOINTEEDATADETAILS';
export const GET_APPOINTEECONTRACTRESPONSEDATA = 'GET_APPOINTEECONTRACTRESPONSEDATA';
export const GET_APPOINTEECONTRACTRESPONSEDATAEXPORT = 'GET_APPOINTEECONTRACTRESPONSEDATAEXPORT';
export const GET_APPOINTEECONTRACTRESPONSEDATADETAILS = 'GET_APPOINTEECONTRACTRESPONSEDATADETAILS';
export const GET_APPOINTEEEXCEPTIONREASON = 'GET_APPOINTEEEXCEPTIONREASON';
export const GET_APPOINTEEEXCEPTIONREASONEXPORT = 'GET_APPOINTEEEXCEPTIONREASONEXPORT';
export const GET_APPOINTEEEXCEPTIONREASONDETAILS = 'GET_APPOINTEEEXCEPTIONREASONDETAILS';
